import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

import './index.scss';

import { pageChanged, voteChatlog } from '../../../../data/redux/page_details/actions';
import * as historyActions from '../../../../data/redux/history_details/actions';
import * as filterActions from '../../../../data/redux/filter_details/actions';
import * as nlpActions from '../../../../data/redux/nlp_details/actions';

import { APP_PAGES, MODULE_DATA, ROUTE_PATH, APP_LAYOUT } from '../../../../data/config/constants';
import { IMG_PERSON, IMG_ERROR, IMG_CHATTING } from '../../../../data/assets/img';
import { showMessage, getUrlParams, getProcessedSelectedFilters } from '../../../../data/config/utils';

import ConversationLoader from '../../components/loaders/conversationloader';
import HistoryList from './historylist';
import ChatInterface from '../../components/chatinterface';
import ProfileCard from '../../components/profilecard';
import ShowMessage from '../../../../components/showmessage';
import SpinnerLoader from '../../../../components/spinnerloader';

class ChatHistory extends Component {
  componentWillMount() {
    let { actions } = this.props;
    actions.pageChanged(APP_PAGES.CHAT_HISTORY, APP_PAGES.CHAT_HISTORY);
  }

  componentDidMount() {
    let { actions, history_details, filter_details, history, admin_details } = this.props;
    if (history_details.current_chat_history_details.active_chat_item && history_details.current_chat_history_details.active_chat_item.sessionId) {
      const url = `${ROUTE_PATH.CHAT_HISTORY}?sessionId=${history_details.current_chat_history_details.active_chat_item.sessionId}&platform=${history_details.current_chat_history_details.active_chat_item.platform}&startDate=${history_details.selected_date_range[0]}&endDate=${history_details.selected_date_range[1]}`;
      history.push(url);
    }
    if (history_details.current_chat_history_details.messages.length === 0) {
      const params = getUrlParams();
      let payload = {
        agentId: admin_details.admin_id,
        skip: 0,
        required: MODULE_DATA.HISTORY.LOAD_MORE_HISTORY_COUNT,
        filters: {
          startDate: history_details.selected_date_range && history_details.selected_date_range.length > 0 ? history_details.selected_date_range[0] : "",
          endDate: history_details.selected_date_range && history_details.selected_date_range.length > 0 ? history_details.selected_date_range[1] : "",
        },
      };
      if (params.startDate && params.endDate) {
        payload = {
          ...payload,
          filters: {
            startDate: moment.unix(params.startDate / 1000),
            endDate: moment.unix(params.endDate / 1000),
          },
        };
        actions.updateSelectedDateRange([payload.filters.startDate, payload.filters.endDate]);
      }
      actions.getChatHistory(payload, data => {
        if (params.sessionId && params.platform) {
          if (data && data.chatSessions) {
            const chat_item = data.chatSessions.find(item => item.sessionId === params.sessionId);
            if (chat_item) {
              const permissions = this.checkPermissionsByChannel(chat_item.platform);
              actions.getCurrentChatHistory({ sessionId: params.sessionId }, () => {
                actions.setCurrentHistoryChatItem({ ...chat_item, ...permissions });
              });
            } else {
              history.push(ROUTE_PATH.CHAT_HISTORY);
              showMessage('warning', `${params.sessionId} // this session is not avaliable in chatlist please select filter.`);
            }
          } else {
            history.push(ROUTE_PATH.CHAT_HISTORY);
          }
        }
      });
    }
    actions.getAllIntents();
    actions.getAllEntities();
    if (filter_details.filters.length === 0) {
      actions.getFiltersData();
    }
  }

  handleDateRangeChange = value => {
    let { actions, history_details, history, admin_details } = this.props;
    let processed_filters = getProcessedSelectedFilters(history_details.selected_filters);
    let payload = {
      agentId: admin_details.admin_id,
      skip: 0,
      required: MODULE_DATA.HISTORY.LOAD_MORE_HISTORY_COUNT,
      filters: {
        ...processed_filters,
        startDate: value && value.length > 0 ? value[0] : "",
        endDate: value && value.length > 0 ? value[1] : "",
      }
    };
    actions.updateSelectedDateRange(value);
    actions.getChatHistory(payload, data => {
      const params = getUrlParams();
      if (params.sessionId && data && data.chatSessions) {
        const index = data.chatSessions.findIndex(item => item.sessionId === params.sessionId);
        if (index === -1) {
          history.push(ROUTE_PATH.CHAT_HISTORY);
        }
      }
    });
  };

  applyFilter = () => {
    const { actions, history_details, history, admin_details } = this.props;
    let processed_filters = getProcessedSelectedFilters(history_details.selected_filters);
    let payload = {
      agentId: admin_details.admin_id,
      skip: 0,
      required: MODULE_DATA.HISTORY.LOAD_MORE_HISTORY_COUNT,
      filters: {
        ...processed_filters,
        startDate: history_details.selected_date_range && history_details.selected_date_range.length > 0 ? history_details.selected_date_range[0] : "",
        endDate: history_details.selected_date_range && history_details.selected_date_range.length > 0 ? history_details.selected_date_range[1] : "",
      }
    };
    actions.getChatHistory(payload, data => {
      const params = getUrlParams();
      if (params.sessionId && data && data.chatSessions) {
        const index = data.chatSessions.findIndex(item => item.sessionId === params.sessionId);
        if (index === -1) {
          history.push(ROUTE_PATH.CHAT_HISTORY);
        }
      }
    });
  };

  checkPermissionsByChannel = channel => {
    const { admin_details } = this.props;
    let permissions = {
      isTakeoverAllowed: true,
      isTrainingAllowedOnMessages: true,
    };
    if (channel && admin_details.allowedChannels.length > 0) {
      const index = admin_details.allowedChannels.findIndex(item => item.value === channel);
      if (index !== -1) {
        permissions = {
          isTakeoverAllowed: typeof (admin_details.allowedChannels[index].isTakeoverAllowed) === 'boolean' ? admin_details.allowedChannels[index].isTakeoverAllowed : true,
          isTrainingAllowedOnMessages: typeof (admin_details.allowedChannels[index].isTrainingAllowedOnMessages) === 'boolean' ? admin_details.allowedChannels[index].isTrainingAllowedOnMessages : true
        };
      }
    }
    return permissions;
  };

  handleChatItemClicked = current_item => {
    const { actions, history_details, history } = this.props;
    if (history_details.current_chat_history_details.active_chat_item && history_details.current_chat_history_details.active_chat_item.sessionId && history_details.current_chat_history_details.active_chat_item.sessionId === current_item.sessionId) {
      showMessage('warning', 'History for this chat item is already loaded.');
    } else {
      history.push(`${ROUTE_PATH.CHAT_HISTORY}?sessionId=${current_item.sessionId}&platform=${current_item.platform}&startDate=${history_details.selected_date_range[0]}&endDate=${history_details.selected_date_range[1]}`);
      const permissions = this.checkPermissionsByChannel(current_item.platform);
      const payload = { sessionId: current_item.sessionId };
      actions.getCurrentChatHistory(payload, () => {
        actions.setCurrentHistoryChatItem({ ...current_item, ...permissions });
      });
    }
  };

  closeChatInterface = () => {
    const { history, actions } = this.props;
    history.push(ROUTE_PATH.CHAT_HISTORY);
    actions.clearCurrentHistoryChatItem();
  };

  submitCustumAgentNoteForm = (form, callback) => {
    const { history_details, actions } = this.props;
    if (history_details.current_chat_history_details.active_chat_item) {
      const payload = {
        sessionId: history_details.current_chat_history_details.active_chat_item.sessionId,
        customAgentNotes: {},
      };
      form.forEach(item => {
        payload.customAgentNotes[item.name] = item.value;
      });
      actions.updateCustumAgentNoteFormInHistory(payload, form, callback);
    }
  }

  handleChatEvent = (text, value) => {
    const { actions, history_details } = this.props;
    if (text === 'reviewDone' && history_details.current_chat_history_details.active_chat_item) {
      const payload = {
        sessionId: history_details.current_chat_history_details.active_chat_item.sessionId,
        reviewStatus: value
      };
      actions.updateReviewStatusInHistory(payload);
    }
  }

  renderProfileCard = () => {
    const { history_details } = this.props;
    if (!isEmpty(history_details.current_chat_history_details.user_profile_details)) {
      return (
        <ProfileCard
          profile_details={history_details.current_chat_history_details.user_profile_details}
          submitCustumAgentNoteForm={this.submitCustumAgentNoteForm} />
      );
    } else {
      return (
        <ShowMessage
          img_src={IMG_PERSON}
          message="Profile details are not avaliable"
          height={100}
          width={50}
          color='primary'
        />
      );
    }
  };

  renderChatItemDetails = () => {
    const { isActionPermitted, screen_height, screen_width, history_details } = this.props;
    const is_mobile = screen_width < 768;
    if (history_details.loaders.current_chat_history_load_error) {
      return (
        <Col xs={24} md={18} className={`${is_mobile ? "ori-bg-white ori-b-mrgn-10" : "ori-bg-white ori-full-parent-height"}`}>
          <ShowMessage img_src={IMG_ERROR} title="Error" message="Unable to load chatlog details. Something went wrong." height={180} width={180} />
        </Col>
      );
    }
    if (history_details.current_chat_history_details.active_chat_item) {
      return (
        <Fragment>
          <Col xs={24} md={12} id='chatWindow' className={`${is_mobile ? "ori-bg-white ori-b-mrgn-10" : "ori-bg-white ori-full-parent-height"}`} style={is_mobile ? { height: `${screen_height - APP_LAYOUT.APP_HEADER_HEIGHT - 20}px` } : {}}>
            <ChatInterface
              isActionPermitted={isActionPermitted}
              messages={history_details.current_chat_history_details.messages}
              active_chat_item={history_details.current_chat_history_details.active_chat_item}
              onClickClose={this.closeChatInterface}
              handleChatEvent={this.handleChatEvent}
              show_customer_votes={true}
            />
          </Col>
          <Col xs={24} md={6} id="clientProfile" className={`${is_mobile ? "ori-bg-white ori-b-mrgn-10" : " ori-bg-white ori-full-parent-height ori-l-border-light ori-overflow-auto"}`}>
            {this.renderProfileCard()}
          </Col>
        </Fragment>
      );
    }
    return (
      <Col xs={24} md={18} className={`${is_mobile ? "ori-bg-white ori-b-mrgn-10" : "ori-bg-white ori-full-parent-height"}`}>
        <ShowMessage img_src={IMG_CHATTING} title="Chat history" message="Please click on chat history item to see chatlog details." height={180} width={180} />
      </Col>
    );
  };

  render() {
    const { screen_height, screen_width, history_details, filter_details, nlp_details, admin_details, actions } = this.props;
    const is_mobile = screen_width < 768;
    const current_session_id = history_details.current_chat_history_details.active_chat_item && history_details.current_chat_history_details.active_chat_item.sessionId ? history_details.current_chat_history_details.active_chat_item.sessionId : null;

    if (filter_details.loaders.filters_loading || nlp_details.loaders.intents_loading) {
      return (
        <ConversationLoader screen_width={screen_width} />
      );
    } else if (!filter_details.loaders.filters_loading && !nlp_details.loaders.intents_loading && !filter_details.loaders.filters_loaded) {
      return (
        <div className="oriChatHistoryContainer">
          <ShowMessage img_src="" message="Something went wrong please check internet connection and refresh the page" />
        </div>
      );
    } else if (filter_details.loaders.filters_loaded && nlp_details.loaders.intents_loaded) {
      return (
        <Row className="ori-relative oriChatHistoryContainer">
          {
            history_details.loaders.current_chat_history_loading &&
            <div className="ori-absolute ori-align-full ori-zindex-100 ori-bg-white ori-opacity-medium">
              <SpinnerLoader size="large" text="loading" />
            </div>
          }
          <Col
            xs={24}
            md={6}
            id='chatList'
            className={`${is_mobile ? "ori-bg-white ori-b-mrgn-10 ori-b-pad-10" : "ori-relative ori-full-parent-height ori-bg-white ori-r-border-light"}`}
            style={{
              height: is_mobile ? `${screen_height - APP_LAYOUT.APP_HEADER_HEIGHT - 100}px` : ""
            }}
          >
            {
              history_details.loaders.history_loading &&
              <div className="ori-absolute ori-align-full ori-bg-white ori-zindex-1 ori-opacity-medium">
                <SpinnerLoader text='loading' />
              </div>
            }
            <HistoryList agentId={admin_details.admin_id} selected_date_range={history_details.selected_date_range} filters={filter_details.filters} selected_filters={history_details.selected_filters} chat_history_list={history_details.chat_history_list} load_more_history={history_details.load_more_history} total_history_count={history_details.total_history_count} actions={actions} screen_height={screen_height} current_session_id={current_session_id} handleChatItemClicked={this.handleChatItemClicked} handleDateRangeChange={this.handleDateRangeChange} applyFilter={this.applyFilter} event_permissions={admin_details.user_info.permissions && admin_details.user_info.permissions.events ? admin_details.user_info.permissions.events : {}} />
          </Col>
          {this.renderChatItemDetails()}
        </Row >
      );
    }
    return null;
  }
}

const mapStateToProps = state => {
  return {
    screen_height: state.page_details.device_data.screen_height,
    screen_width: state.page_details.device_data.screen_width,
    admin_details: state.admin_details,
    filter_details: state.filter_details,
    nlp_details: state.nlp_details,
    history_details: state.history_details
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(Object.assign({}, { pageChanged, voteChatlog }, historyActions, filterActions, nlpActions), dispatch)
  };
};

ChatHistory.propTypes = {
  history: PropTypes.object,
  actions: PropTypes.object,
  screen_height: PropTypes.number,
  screen_width: PropTypes.number,
  admin_details: PropTypes.object,
  filter_details: PropTypes.object,
  nlp_details: PropTypes.object,
  history_details: PropTypes.object,
  isActionPermitted: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(ChatHistory);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/history/index.js